/** Home page academic service, such as reviewing. */
import React from 'react';

import { useSiteMetadata } from '../../../utils/hooks';

import * as styles from './homePage.module.less';

/** Render each service role as one line, e.g. "Reviewer: ICML 2026, NeurIPS 2025". */
const Service = () => {
  const { service } = useSiteMetadata();
  if (!service || service.length === 0) return null;
  return (
    <div className={styles.homepageSection}>
      <div className={styles.sectionHeading}>
        <h2>Service</h2>
      </div>
      {service.map((item) => (
        <p key={item.role} className={styles.serviceLine}>
          <span className={styles.datedListTitle}>{item.role}</span>
          {`: ${item.venues}`}
        </p>
      ))}
    </div>
  );
};

export default Service;
